import { Box, Typography } from '@mui/material';

export const Screen8BusinessChallenges = ({ selectedIndustry }) => {
  if (!selectedIndustry) return null;

  return (
    <div className="p-6">
      <Typography fontSize={35} textAlign="center">
        Business Challenges
      </Typography>
      <Box ml={4}>
        {selectedIndustry.BusinessChallenges.map((challenge, index) => (
          <Typography key={index} component="li" fontSize={22} mt={2} lineHeight={1.3}>
            {challenge}
          </Typography>
        ))}
      </Box>
    </div>
  );
};
